// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__xR6yj"};